// Configurateur — etat en memoire, ajout panier reel (/cart/add.js) sur le
// CTA du recap, voir submitToCart() en bas de fichier. Un seul cadre
// existe, donc plus de matrice de compatibilite type de jeu <-> surface —
// chaque type de jeu EST directement une surface de frappe.
//
// 2026-09-03 : trackEvent() (add-click/add-success/add-error) relaie aussi
// vers window.HexagonAnalytics (assets/hexagon-analytics.js ->
// Shopify.analytics.publish) en plus du CustomEvent interne — audit/mise
// en place analytics, brief dedie. L'evenement "surface-change" (fin de
// renderRecap) N'EST PAS relaye — se declenche aussi a chaque frappe dans
// le champ de gravure, trop bruyant sans debounce dedie (voir commentaire
// sur place).
//
// 2026-08-01 : brief panier (docs — brief-panier-et-ajout-configurateur).
// Chaque "configuration" ajoutee au panier = 1 a 3 lignes Shopify reelles
// (raquette + supplement finition + gravure, voir plus bas) partageant une
// propriete cachee _config_id commune, pour que la page panier les
// regroupe visuellement en UNE carte "Raquette Hexagon" (brief : "ne pas
// afficher le cadre/tamis/logo/gravure comme des produits independants").
// _config_json (JSON.stringify de l'etat) permet de rouvrir le
// configurateur pre-rempli via /pages/configurer-ma-raquette?edit=<id> et
// de mettre a jour la ligne existante plutot que d'en creer une 2e
// (removeExistingConfigLines() avant le nouvel ajout).
//
// Image recap panier : pas d'app/API admin dans ce projet -> composer un
// vrai fichier PNG (canvas) et l'uploader durablement n'est pas faisable
// sans infra dediee. A la place, _photo_url et _logo_url (memes URLs
// Shopify Files persistantes que le configurateur) sont empilees en CSS
// sur la page panier (sections/main-cart.liquid) — visuellement identique,
// sans generer de nouveau fichier.
(function () {
  var root = document.querySelector('[data-configurateur]');
  if (!root) return;

  // 2026-08-08 (sanity check "boutons email" — url .../contact#... /
  // ?contact_posted=true parfois vues au lieu du toast) : ce bloc doit
  // s'attacher EN TOUT PREMIER, avant tout le reste de ce fichier. Ce
  // fichier est un unique IIFE : si une erreur JS survient plus loin
  // (rendu des options, panier, IntersectionObserver...), tout le code
  // ecrit APRES le point de plantage n'est jamais execute — y compris,
  // avant ce correctif, l'interception AJAX du formulaire "Etre informe du
  // lancement", qui vivait tout en bas du fichier. Sans elle, le
  // formulaire redevenait un <form> Shopify natif normal : submit = vrai
  // POST + rechargement vers /contact#ConfiguratorNotifyForm (ou vers la
  // page avec ?contact_posted=true en cas de succes) au lieu du toast —
  // exactement le symptome remonte, et "parfois" puisque conditionne par
  // un plantage plus loin dans le fichier, pas systematique. Deplace ici +
  // isole dans son propre try/catch : garanti d'attacher quoi qu'il arrive
  // ENSUITE dans le reste du script.
  try {
    var notifyForm = document.getElementById('ConfiguratorNotifyForm');
    var notifyBodyField = root.querySelector('[data-configurateur-notify-body]');
    var notifyWrap = root.querySelector('[data-configurateur-notify]');
    if (notifyForm && notifyBodyField && notifyWrap && window.HexagonContactForm) {
      window.HexagonContactForm.init(notifyForm, {
        trackingConfig: function () {
          if (!openingConfigId) openingConfigId = buildConfigId();
          return trackingConfig(openingConfigId);
        },
        successTitle: notifyWrap.getAttribute('data-toast-success-title'),
        successText: notifyWrap.getAttribute('data-toast-success-text'),
        beforeSubmit: function () {
          // 2e try/catch dedie : les fonctions/variables ci-dessous
          // (surfaceData, state, LOGO_CHOICES...) sont definies plus bas
          // dans ce fichier. Les fonctions declarees (function xxx() {})
          // sont hissees (hoisted) et toujours disponibles ; state/
          // LOGO_CHOICES sont des "var" assignees tot dans le fichier (bien
          // avant le rendu risque) mais, par prudence, un echec ici ne doit
          // JAMAIS empecher l'envoi du formulaire — juste degrader le texte
          // du resume envoye a Hexagon.
          try {
            var s = surfaceData(state.surface);
            var texture = textureData(state.texture);
            var hasEngraving = state.engraving.trim().length > 0;
            var logo = null;
            LOGO_CHOICES.forEach(function (l) { if (l.id === state.logoColor) logo = l; });
            var lines = [
              'Cette personne a configuré une raquette sur la homepage et souhaite être informée du lancement.',
              '',
              'Configuration en cours :',
              '- Type de jeu : ' + s.label,
              '- Surface de frappe : ' + (texture ? textureLabel(texture) : '—'),
              '- Couleur surface : ' + finishSummary(),
              '- Couleur logo : ' + (logo ? logo.label : '—'),
              '- Gravure : ' + (hasEngraving ? state.engraving.trim() : 'Aucune')
            ];
            notifyBodyField.value = lines.join('\n');
          } catch (summaryErr) {
            notifyBodyField.value = 'Cette personne a configuré une raquette sur la homepage et souhaite être informée du lancement.';
          }
        }
      });
    }
    // Configuration en cours, lue par assets/brevo-signup.js a l'inscription (attributs HP_CONFIG_*).
    window.HexagonBrevoConfig = function () {
      var jeux = { mc: 'Equilibre', cc: 'Puissance', lin: 'Contrôle' };
      var logos = { 'logo-tricolore': 'Tricolore', 'logo-gold': 'Jaune', 'logo-red': 'Rouge', 'logo-green': 'Vert', 'logo-blue': 'Bleu' };
      var color = null;
      paletteFor(state.finish).forEach(function (c) { if (c.id === state.accentColor) color = c; });
      var finition = state.finish.charAt(0).toUpperCase() + state.finish.slice(1);
      return {
        jeu: jeux[state.surface] || '',
        surface: state.texture === 'texturee-sablee' ? 'Sablée' : 'Texturée',
        finition: finition,
        couleurFinition: state.finish !== 'brut' && color ? color.name : '',
        logo: logos[state.logoColor] || '',
        gravure: state.engraving.trim()
      };
    };
  } catch (notifyInitErr) {
    // Le "belt and suspenders" ultime reste le petit script inline dans
    // sections/configurateur.liquid (preventDefault seul, sans dependance)
    // — meme si CE bloc echoue completement, aucune navigation native ne
    // peut se produire.
  }

  // 2026-08-07 : le TEXTE de la composition (ex. "1 couche carbone non
  // tisse 100 g/m²") vient desormais du metaobjet "Raquettes" (champ
  // "Composition tamis", r.composition — meme source que la page "Choisir
  // mon tamis") plutot que d'etre duplique en dur ici — feedback explicite
  // : modifier le metaobjet ne mettait a jour QUE la page tamis, pas ce
  // module, source de confusion. Seules les METADONNEES VISUELLES restent
  // en dur dans STYLE_SURFACES_VISUALS[id].layerMeta (une entree par ligne
  // de texte ATTENDUE, dans le meme ordre que le metaobjet) :
  //   - layers = nombre de couches physiques que represente la ligne (ex.
  //     "2 couches carbone tisse" = 1 ligne mais 2 couches empilees) ;
  //   - illustrationAnchors[i] = position(s) verticale(s) (% depuis le haut
  //     de assets/Equilibre|Puissance|Controle.png) du/des calque(s) de la
  //     ligne i, mesure par echantillonnage de pixels (colonne a 10% de la
  //     largeur, ou les bandes sont nettement separees — au centre elles se
  //     chevauchent visuellement). Ces % NE PEUVENT PAS venir d'un champ
  //     admin (mesure pixel sur l'image, pas du contenu editorial).
  // Limite a connaitre : si le metaobjet a MOINS de lignes que layerMeta,
  // les dernieres lignes de texte restent vides (le trait pointe quand meme
  // vers l'image) ; si il en a PLUS, les lignes en trop sont ignorees. Le
  // nombre de lignes doit donc rester aligne avec layerMeta ci-dessous a
  // chaque modification du metaobjet.
  //
  // 2026-09-07 : ligne "fibre de verre" retiree des 3 tamis (le metaobjet
  // "Composition tamis" ne l'expose plus en texte — demande explicite) —
  // layerMeta/illustrationAnchors n'avaient plus le meme nombre d'entrees
  // que le texte reel, ce qui decalait les traits (texte "carbone tisse"
  // affiche sur la mauvaise couche, les vraies couches carbone tisse se
  // retrouvant sans texte associe). Positions verticales (% depuis le
  // haut) fournies directement par Maxime (mesure sur les images CDN
  // actuelles), une seule valeur = un seul trait, deux valeurs = deux
  // traits vers la meme ligne de texte ("2 couches").
  // 2026-09-09 : positions (top, % depuis le HAUT de .tamis-connector
  // __rows) fournies par Maxime via le cadre de reperage noir — Equilibre
  // 29/60, Puissance 17/37/68, Controle 37/60.
  // 2026-09-09 (maj) : nouvelle adresse % top pour Puissance (tableau
  // Controle/Equilibre/Puissance) — Puissance passe de 17/37/68 a
  // 12/40/68 (L3 inchangee). Controle (37/60) et Equilibre (29/60)
  // inchangees, valeurs identiques a la mesure precedente.
  var STYLE_SURFACES_VISUALS = {
    mc: {
      layerMeta: [
        { layers: 1, material: 'carbone-non-tisse' },
        { layers: 2, material: 'carbone-tisse' }
      ],
      positions: [29, 60]
    },
    cc: {
      layerMeta: [
        { layers: 1, material: 'torons-carbone' },
        { layers: 1, material: 'carbone-non-tisse' },
        { layers: 2, material: 'carbone-tisse' }
      ],
      positions: [12, 40, 68]
    },
    lin: {
      layerMeta: [
        { layers: 1, material: 'chanvre' },
        { layers: 1, material: 'carbone-tisse' }
      ],
      positions: [37, 60]
    }
  };
  var RAQUETTES_DATA = window.HexagonRaquettesData || [];
  // 2026-08-13 : prix = celui du vrai produit Shopify "Raquette" associe
  // (window.HexagonRaquettePrices, voir sections/configurateur.liquid),
  // demande explicite ("Prix du produit Raquette associe") — le champ
  // editorial r.price (metaobjet) sert seulement de repli si le produit
  // est absent/depublie.
  // Prix des variantes (surface x gravure) : SEULE source des prix quand
  // elles existent — le total affiche = ce qui est facture au panier.
  // Cles : t/s (texturee/sablee) + n/g (sans/avec gravure).
  var MATRIX_PRICES = window.HexagonRaquetteMatrixPrices || {};
  function matrixPrice(surface, key) {
    var m = MATRIX_PRICES[surface];
    return m && typeof m[key] === 'number' ? m[key] : null;
  }
  var RAQUETTE_PRICES = window.HexagonRaquettePrices || {};
  Object.keys(MATRIX_PRICES).forEach(function (sid) {
    var base = matrixPrice(sid, 'tn');
    if (base !== null) RAQUETTE_PRICES[sid] = base;
  });
  var STYLE_SURFACES = RAQUETTES_DATA.map(function (r) {
    var visuals = STYLE_SURFACES_VISUALS[r.id] || { layerMeta: [], positions: null };
    var metaTexts = r.composition || [];
    var composition = visuals.layerMeta.map(function (meta, i) {
      return { text: metaTexts[i] || '', layers: meta.layers, material: meta.material };
    });
    return {
      id: r.id,
      label: r.label,
      price: RAQUETTE_PRICES[r.id] || r.price,
      desc: r.desc,
      // "Votre tamis" (module sous le selecteur type de jeu) utilise un texte
      // dedie (champ metaobjet configurateur_votre_tamis), distinct de la
      // citation testeur (r.claim / key_verbatim) utilisee sur "Choisir mon
      // tamis" — feedback explicite du 2026-07-25.
      claim: r.configuratorClaim,
      resume: r.resume,
      composition: composition,
      positions: visuals.positions
    };
  });
  // 2026-07-31 : les couleurs (4 x 3 types) viennent du metaobjet "Finition
  // configurateur" (voir snippets/finitions-data.liquid). Le libelle des 4
  // onglets (Brut/Fibres/Flocons/Paillettes) reste en dur : c'est une
  // taxonomie fixe, pas du contenu editorial — un onglet Fibres/Flocons/
  // Paillettes apparait des qu'au moins une entree de ce type existe dans
  // le metaobjet, active ou non (voir plus bas pour le grisage).
  // "Brut" reste TOUJOURS disponible (jamais gate par le metaobjet) : c'est
  // l'etat par defaut du tamis, pas une option qui peut manquer de stock —
  // 2026-08-01 : etait gate comme les autres par erreur, l'onglet
  // disparaissait completement des que l'entree Brut n'etait pas cochee
  // "Actif" dans l'admin.
  // 2026-08-02 : desactiver une entree cote admin ("Actif" = faux) ne la
  // retire plus du configurateur — elle reste visible mais grisee/non
  // cliquable (voir paletteFor ci-dessous), pour que le client comprenne
  // qu'une couleur existe mais est temporairement indisponible plutot que
  // de la voir disparaitre sans explication (ex. rupture de stock).
  var FINISH_TAB_LABELS = { brut: 'Brut', fibres: 'Fibres metalliques', flocons: 'Flocons metalliques', paillettes: 'Paillettes' };
  // 2026-09-04 (brief "configurateur mobile") : tab.label reste du texte
  // brut PARTOUT (finishSummary(), recap, proprietes panier — voir plus
  // bas, plusieurs endroits l'inserent en textContent ou l'envoient tel
  // quel a Shopify) — on ne peut donc pas y injecter du HTML directement.
  // pillLabelHtml() ne s'applique qu'au balisage du pill lui-meme
  // (renderFinishGroup, innerHTML) : enveloppe "metalliques" dans un span
  // masque en CSS sous 900px, sans toucher a la donnee partagee.
  function pillLabelHtml(label) {
    return label.replace(/ metalliques$/i, ' <span class="config-word-metallique">metalliques</span>');
  }
  var FINITIONS_DATA = window.HexagonFinitionsData || [];
  var FINISH_TABS = [{ id: 'brut', label: FINISH_TAB_LABELS.brut }].concat(
    ['fibres', 'flocons', 'paillettes']
      .filter(function (type) { return FINITIONS_DATA.some(function (f) { return f.type === type; }); })
      .map(function (type) { return { id: type, label: FINISH_TAB_LABELS[type] }; })
  );
  var SURFACES_BRUT_ONLY = ['lin'];
  function paletteFor(type) {
    return FINITIONS_DATA
      .filter(function (f) { return f.type === type; })
      .sort(function (a, b) { return a.order - b.order; })
      .map(function (f) { return { id: f.couleur, name: f.label, active: !!f.actif }; });
  }
  // Supplement de prix facture par type de finition — vient d'un produit
  // Shopify dedie par type (voir sections/configurateur.liquid), ajoute
  // comme 2e ligne au panier a cote de la raquette, jamais calcule "a la
  // main" : le prix affiche ici doit toujours correspondre a ce qui est
  // reellement encaisse au panier.
  var FINITION_ADDONS = window.HexagonFinitionAddons || {};
  // 2026-08-13 : "Texture de surface" — 2 produits Shopify dedies
  // (window.HexagonTextureOptions, voir sections/configurateur.liquid),
  // meme principe que FINITION_ADDONS : le supplement de prix (option
  // "Texturée et sablée", +15E) vient du vrai produit, jamais calcule "a la
  // main". "Texturée" (1re entree) est le choix par defaut/gratuit.
  var TEXTURE_OPTIONS = window.HexagonTextureOptions || [];
  function textureData(id) {
    var found = null;
    TEXTURE_OPTIONS.forEach(function (o) { if (o.id === id) found = o; });
    return found;
  }
  // 2026-08-13 (bis) : le libelle affiche/facture retire le prefixe
  // "Surface " du titre produit ("Surface texturée" -> "Texturée") — demande
  // explicite, le mot est redondant vu le contexte (etape "Texture de
  // surface", ligne recap desormais nommee "Surface de frappe").
  function textureLabel(t) {
    if (!t) return '';
    var label = t.label.replace(/^Surface\s+/i, '');
    return label.charAt(0).toUpperCase() + label.slice(1);
  }
  var LOGO_CHOICES = [
    { id: 'logo-tricolore', label: 'Tricolore', hex: null },
    { id: 'logo-gold', label: 'Doré', hex: '#C7A24A' },
    { id: 'logo-red', label: 'Rouge', hex: '#ED2939' },
    { id: 'logo-green', label: 'Vert', hex: '#1B4332' },
    { id: 'logo-blue', label: 'Bleu', hex: '#002395' }
  ];
  // Prix produit Shopify "Gravure" (gravure payante) — voir
  // sections/configurateur.liquid. Fallback 20 si le produit est absent/depublie.
  // Precommande (site_phase == pre_order) : gravure offerte — pas de ligne
  // panier facturee, le texte reste porte par la propriete "Gravure".
  var ENGRAVING_FREE = window.HexagonEngravingFree === true;
  var ENGRAVING_PRICE = ENGRAVING_FREE ? 0 : (window.HexagonEngravingPrice || 20);
  function engravingExtra(surface) {
    if (ENGRAVING_FREE) return 0;
    var g = matrixPrice(surface, 'tg'), n = matrixPrice(surface, 'tn');
    return (g !== null && n !== null) ? Math.max(0, g - n) : ENGRAVING_PRICE;
  }
  function textureExtra(o, surface) {
    if (!o) return 0;
    var s = matrixPrice(surface, 'sn'), n = matrixPrice(surface, 'tn');
    if (s !== null && n !== null) return o.id === 'texturee-sablee' ? Math.max(0, s - n) : 0;
    return o.price;
  }
  var ASSETS = window.HexagonConfigAssets || { surfaceIllustrations: {}, finishTextures: {} };
  // 2026-08-06 (brief "Pre Pre lancement") : aucune notion de prix affichee
  // tant que settings.site_phase != 'live' (voir sections/configurateur.liquid,
  // window.HexagonShowPrices). Par defaut a true si jamais absent (theme
  // publie sans ce script inline, comportement historique preserve).
  var SHOW_PRICES = window.HexagonShowPrices !== false;
  // 2026-09-08 (Lot 8) : le prix de la gravure s'affiche desormais
  // directement sur le bouton "Gravure personnalisee" (voir
  // renderEngraveGroup() plus bas) — l'ancien [data-engrave-price] a cote
  // du label d'etape n'existe plus dans le markup.

  // 2026-08-01 : rendu produit reel (photo raquette + calque logo) — voir
  // snippets/configurator-media.liquid (fichiers uploades dans Contenu >
  // Fichiers, convention de nommage documentee dans ce snippet), injecte
  // dans window.HexagonConfiguratorMedia. Une photo/calque absent(e) => cle
  // absente du JSON => on retombe sur le placeholder gris existant.
  var MEDIA = window.HexagonConfiguratorMedia || { photos: {}, logos: {} };
  // 2026-08-27 : retour a 4 photos (etait passe a 7 le 2026-08-16, voir
  // snippets/configurator-media.liquid) — constante partagee pour eviter
  // de re-coder ce chiffre a plusieurs endroits. Le carrousel de vignettes
  // (fleches/scroll, voir initThumbsCarousel plus bas) reste tel quel : a
  // 4 vignettes visibles pour 4 au total, il se desactive tout seul (rien
  // a faire defiler), sans qu'aucun code n'ait ete retire.
  var CONFIGURATEUR_PHOTO_COUNT = 4;
  var TAMIS_SLUGS = { mc: 'equilibre', cc: 'puissance', lin: 'controle' };
  var LOGO_SUFFIXES = { 'logo-tricolore': 'tricolore', 'logo-gold': 'dore', 'logo-red': 'rouge', 'logo-green': 'vert', 'logo-blue': 'bleu' };
  function finitionMediaKey() {
    return state.finish === 'brut' ? 'brut' : (state.finish + '-' + state.accentColor);
  }
  function photoUrl(n) {
    var slug = TAMIS_SLUGS[state.surface];
    return MEDIA.photos[slug + '|' + finitionMediaKey() + '|' + n] || '';
  }
  function logoOverlayUrl(n) {
    // 2026-08-16 : calque logo partage entre les 3 tamis (plus de prefixe
    // slug dans la cle) — voir snippets/configurator-media.liquid.
    var suffix = LOGO_SUFFIXES[state.logoColor];
    return MEDIA.logos[n + '|' + suffix] || '';
  }

  // 2026-08-01 : le calque logo n'etait fetch par le navigateur qu'au
  // moment ou l'utilisateur changeait de couleur (l'<img> n'existe pas
  // avant), d'ou un flash/latence visible a chaque clic. On precharge en
  // silence (objets Image() jamais inseres dans la page, juste mis en
  // cache HTTP par le navigateur) les 5 couleurs de logo pour les 4
  // positions du tamis actuellement affiche — pas les 60 combinaisons du
  // site entier, seulement les 20 pertinentes pour la config en cours.
  // preloadedUrls evite de refetcher une URL deja demandee.
  var preloadedUrls = {};
  function preloadImage(url) {
    if (!url || preloadedUrls[url]) return;
    preloadedUrls[url] = true;
    var img = new Image();
    img.src = url;
  }
  function preloadLogosForCurrentTamis() {
    // 2026-08-16 : calque logo partage entre tamis (voir logoOverlayUrl) —
    // le nom de la fonction reste inchange (appelee au changement de tamis)
    // mais precharge desormais le meme jeu de calques quel que soit le
    // tamis actif.
    for (var n = 1; n <= CONFIGURATEUR_PHOTO_COUNT; n++) {
      Object.keys(LOGO_SUFFIXES).forEach(function (logoId) {
        preloadImage(MEDIA.logos[n + '|' + LOGO_SUFFIXES[logoId]]);
      });
    }
  }

  // 2026-09-08 (Lot 8) : engraveChoice ('none'/'custom') pilote uniquement
  // l'affichage (bouton actif, champ+image reveles) — le prix/panier/recap
  // continuent de se baser sur state.engraving (texte non vide), inchange,
  // pour ne pas toucher a la logique deja en prod (submitToCart, recap,
  // total). engraveInfoOpen : etat du (i) du bouton "Gravure personnalisee"
  // (independant du choix, voir renderEngraveGroup()).
  var state = { surface: 'mc', finish: 'brut', accentColor: '', logoColor: 'logo-tricolore', engraving: '', engraveChoice: 'none', engraveInfoOpen: false, texture: (TEXTURE_OPTIONS[0] || {}).id || 'texturee' };
  // 2026-08-17 : numero (1-7) de la photo affichee en grand — separe de
  // `state` (ne fait pas partie de la configuration produit, jamais
  // envoye au panier/sauvegarde). Volontairement PERSISTANT a travers les
  // re-rendus (changement de tamis/finition/couleur/texture/logo) : le
  // clic sur une vignette ne fait plus qu'un simple SELECT (numero affiche
  // + aria-pressed), il n'echange plus le contenu des vignettes entre
  // elles (l'ordre 1-7 reste fixe) — demande explicite ("1 est toujours la
  // premiere du carrousel, pas d'echange selon le clic" / "si on change de
  // finition, on doit rester sur le meme numero de photo").
  var selectedPhotoIndex = 1;

  // Pre-selection depuis la page "Choisir mon tamis" (assets/tamis-picker.js
  // pointe vers /?style=<id>#configurateur) : si le parametre correspond a
  // un type de jeu reel, on l'applique avant le premier rendu.
  (function applyPreselectedStyle() {
    var styleParam = new URLSearchParams(window.location.search).get('style');
    if (styleParam && STYLE_SURFACES.some(function (s) { return s.id === styleParam; })) {
      state.surface = styleParam;
    }
  })();

  // ?edit=<config_id> (lien "Modifier ma configuration" du panier, voir
  // sections/main-cart.liquid) : la config exacte est restauree de facon
  // asynchrone plus bas (restoreFromCartIfEditing()), une fois le DOM/les
  // handlers en place — le rendu par defaut s'affiche d'abord, puis se
  // met a jour des que /cart.js repond.
  var EDITING_CONFIG_ID = new URLSearchParams(window.location.search).get('edit') || null;

  function trackEvent(name, detail) {
    var fullName = 'hexagon:cart-' + name;
    document.dispatchEvent(new CustomEvent(fullName, { detail: detail || {} }));
    if (window.HexagonAnalytics) window.HexagonAnalytics.publish(fullName, detail);
  }

  function surfaceData(id) {
    var found = null;
    STYLE_SURFACES.forEach(function (s) { if (s.id === id) found = s; });
    return found;
  }
  function isDecorationAllowed() { return SURFACES_BRUT_ONLY.indexOf(state.surface) === -1; }
  function money(n) { return n + ' €'; }
  // --- Tracking GA4 (assets/hexagon-tracking.js, docs/tracking-ga4.md) ---
  // Chaque clic sur un VRAI choix (bouton .option actif) : configurator_start (une fois par parcours)
  // puis customization_select pour chaque option esthetique qui change reellement de valeur.
  // La gravure (texte libre) n'est jamais lue : seulement none / custom.
  var TRACK_KEYS = ['finish', 'accentColor', 'logoColor', 'texture', 'engraveChoice'];
  function trackSnapshot() {
    var o = {};
    TRACK_KEYS.forEach(function (k) { o[k] = state[k]; });
    return o;
  }
  // Groupe du DOM (data-group) -> cle d'etat + libelle GA4. Seul le groupe CLIQUE est trace : les
  // valeurs recalculees automatiquement par renderAll() (ex. couleur par defaut d'une finition) ne
  // sont pas des selections de l'utilisateur.
  var TRACK_GROUPS = {
    texture: { key: 'texture', name: 'texture' },
    finish: { key: 'finish', name: 'finish' },
    color: { key: 'accentColor', name: 'accent_color' },
    logo: { key: 'logoColor', name: 'logo_color' },
    engrave: { key: 'engraveChoice', name: 'engraving', type: 'engraving' }
  };
  function trackChoice(before, groupName) {
    var T = window.HexagonTracking;
    if (!T) return;
    T.started('racket_full');
    var g = TRACK_GROUPS[groupName];
    if (!g || state[g.key] === before[g.key] || !state[g.key]) return;
    T.customization('racket_full', g.name, String(state[g.key]), g.type || 'aesthetic');
  }
  function trackingConfig(configId) {
    return {
      configId: configId,
      tamis: state.surface,
      texture: state.texture,
      finish: state.finish,
      accentColor: state.accentColor || 'none',
      logoColor: state.logoColor,
      engraving: state.engraving.trim().length > 0 ? 'custom' : 'none'
    };
  }
  var openingConfigId = null;
  function makeOption(className, active, disabled, html, onClick) {
    var el = document.createElement('button');
    el.type = 'button';
    el.className = 'option ' + className;
    el.setAttribute('aria-pressed', active ? 'true' : 'false');
    if (disabled) {
      el.classList.add('option--disabled');
      el.disabled = true;
    } else {
      el.addEventListener('click', function (ev) {
        var before = trackSnapshot();
        var holder = el.closest('[data-group]');
        var groupName = holder ? holder.getAttribute('data-group') : '';
        var result = onClick.call(this, ev);
        try { trackChoice(before, groupName); } catch (trackErr) { /* le tracking ne doit jamais bloquer le configurateur */ }
        return result;
      });
    }
    el.innerHTML = '<span class="option__inner">' + html + '</span>';
    return el;
  }

  function renderStyleGroup() {
    var wrap = root.querySelector('[data-group="style"]');
    wrap.innerHTML = '';
    STYLE_SURFACES.forEach(function (s) {
      var el = makeOption(
        'option--style',
        state.surface === s.id,
        false,
        // 2026-09-08 (Lot 8) : le bouton n'affiche plus que le nom du tamis
        // (option__desc, le texte "type de joueur", est retire d'ici) —
        // voir [data-style-desc] plus bas, mis a jour a chaque rendu avec
        // le desc du tamis actuellement selectionne.
        '<span class="option__title">' + s.label + '</span>',
        function () {
          state.surface = s.id;
          if (SURFACES_BRUT_ONLY.indexOf(s.id) !== -1) {
            state.finish = 'brut';
            state.accentColor = '';
          }
          renderAll();
        }
      );
      wrap.appendChild(el);
    });
    var descEl = root.querySelector('[data-style-desc]');
    if (descEl) {
      var current = surfaceData(state.surface);
      descEl.textContent = current ? current.desc : '';
    }
  }

  // 2026-09-09 ("plutot que travailler en numero de ligne, je peux te
  // donner un % depuis la hauteur ?") : chaque ligne de composition est
  // positionnee en absolu (top: X%, depuis le HAUT de .tamis-connector
  // __rows) selon s.positions, fourni par tamis. Tant que positions est
  // absent (aucune valeur fournie pour le moment), rien n'est affiche
  // dans le cadre de reperage (voir assets/base.css, .tamis-connector
  // __rows { border } — delimite visuellement le 0%/100% pour permettre
  // de viser les valeurs a fournir).
  function renderTamisModule() {
    var s = surfaceData(state.surface);
    root.querySelector('[data-tamis-claim]').textContent = s.claim;
    var positions = (s.positions && s.positions.length === s.composition.length) ? s.positions : null;
    var layersEl = root.querySelector('[data-tamis-layers]');
    if (positions) {
      layersEl.innerHTML = s.composition.map(function (row, i) {
        return '<li style="top:' + positions[i] + '%;">' + row.text + '</li>';
      }).join('');
    } else {
      layersEl.innerHTML = '';
    }

    // Illustration reelle (assets/Equilibre|Puissance|Controle.png, fond
    // transparent) affichee en entier (object-fit: contain, voir CSS) —
    // simple affichage, plus de lignes de renvoi calculees par-dessus.
    var iconEl = root.querySelector('[data-tamis-icon]');
    if (iconEl) {
      var img = document.createElement('img');
      img.alt = '';
      img.src = ASSETS.surfaceIllustrations[s.id] || '';
      iconEl.innerHTML = '';
      iconEl.appendChild(img);
    }
  }

  function renderFinishGroup() {
    var wrap = root.querySelector('[data-group="finish"]');
    wrap.innerHTML = '';
    var allowed = isDecorationAllowed();
    FINISH_TABS.forEach(function (tab) {
      var disabled = tab.id !== 'brut' && !allowed;
      var el = makeOption(
        'option--pill',
        state.finish === tab.id,
        disabled,
        '<span>' + pillLabelHtml(tab.label) + '</span>',
        function () {
          state.finish = tab.id;
          if (tab.id === 'brut') state.accentColor = '';
          renderAll();
        }
      );
      wrap.appendChild(el);
    });

    root.querySelector('[data-deco-note]').style.display = allowed ? 'none' : 'block';

    var colorWrap = root.querySelector('[data-group="color"]');
    colorWrap.innerHTML = '';
    var showColors = state.finish !== 'brut' && allowed;
    colorWrap.style.display = showColors ? '' : 'none';
    if (showColors) {
      var palette = paletteFor(state.finish);
      // Si la couleur en memoire est absente ou desactivee cote metaobjet
      // (ou changement de type de finition), on retombe sur la 1re couleur
      // ACTIVE disponible plutot que de garder un choix invalide/indisponible.
      var selected = null;
      palette.forEach(function (c) { if (c.id === state.accentColor) selected = c; });
      if (!selected || !selected.active) {
        var firstActive = null;
        palette.forEach(function (c) { if (!firstActive && c.active) firstActive = c; });
        state.accentColor = firstActive ? firstActive.id : (palette.length ? palette[0].id : '');
      }
      var textures = ASSETS.finishTextures[state.finish] || {};
      palette.forEach(function (c) {
        var el = makeOption(
          'option--swatch',
          state.accentColor === c.id,
          !c.active,
          '<span class="option__swatch-img" style="background-image:url(' + (textures[c.id] || '') + ')"></span><span class="option__swatch-label">' + c.name + '</span>',
          function () { state.accentColor = c.id; renderAll(); }
        );
        colorWrap.appendChild(el);
      });
    }
  }

  // 2026-08-13 : "Texture de surface" — memes gabarits que les swatches de
  // finition (.option__swatch-img, prevu pour recevoir une image plus tard
  // via ASSETS.textureSwatches[id] — vide pour l'instant, cf. media-
  // placeholder gris affiche en attendant).
  // RETOURS (2026-08-14) : bouton "Texturée" reduit a 90% de la taille
  // d'origine, "Texturée et sablée" agrandi a 110% (plus de texte + image +
  // (i) a caser) — voir .option--swatch-texture-sm/--lg dans base.css. Le
  // (i) de chaque bouton n'ouvre plus sa propre bulle individuelle : un seul
  // bloc de texte partage, sous toute la rangee des 2 boutons, affiche la
  // description du bouton dont le (i) vient d'etre clique — plus large, et
  // sa position ne depend plus du bouton selectionne/non selectionne.
  // RETOURS 2 (2026-08-14) : seule la taille du BOUTON differe entre les 2
  // options (padding/image), le texte reste a la meme taille pour les 2.
  // Structure "image a gauche, texte a droite" : le label et la ligne
  // prix+(i) (memes ligne, alignes sous le label) sont regroupes dans
  // .option__swatch-text, l'image ne se repete pas sur 2 lignes.
  function renderTextureGroup() {
    var wrap = root.querySelector('[data-group="texture"]');
    if (!wrap) return;
    wrap.innerHTML = '';

    var sharedTooltip = document.createElement('div');
    sharedTooltip.className = 'option__info-tooltip option__info-tooltip--shared';
    sharedTooltip.setAttribute('data-info-tooltip-shared', '');
    sharedTooltip.hidden = true;

    TEXTURE_OPTIONS.forEach(function (o) {
      var swatchImg = (ASSETS.textureSwatches || {})[o.id];
      var swatch = swatchImg
        ? '<span class="option__swatch-img" style="background-image:url(' + swatchImg + ')"></span>'
        : '<span class="option__swatch-img option__swatch-img--placeholder"></span>';
      var priceText = (SHOW_PRICES && textureExtra(o, state.surface) > 0) ? '(+' + money(textureExtra(o, state.surface)) + ')' : '';
      var price = priceText ? '<span class="option__swatch-price">' + priceText + '</span>' : '';
      var info = o.description
        ? '<span class="option__info" data-info tabindex="0"><span class="option__info-mark" aria-hidden="true">i</span></span>'
        : '';
      var meta = (price || info) ? '<span class="option__swatch-meta">' + price + info + '</span>' : '';
      var text = '<span class="option__swatch-text"><span class="option__swatch-label">' + textureLabel(o) + '</span>' + meta + '</span>';
      var sizeClass = o.id === 'texturee-sablee' ? ' option--swatch-texture-lg' : ' option--swatch-texture-sm';
      var el = makeOption(
        'option--swatch' + sizeClass,
        state.texture === o.id,
        false,
        swatch + text,
        function () { state.texture = o.id; renderAll(); }
      );
      var infoToggle = el.querySelector('[data-info]');
      if (infoToggle) {
        // Clic/tap sur le (i) deplie/replie la description partagee sans
        // selectionner la texture (stopPropagation empeche le clic de
        // remonter jusqu'au bouton parent) — identique clavier/souris et
        // toucher.
        infoToggle.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var alreadyShowingThis = !sharedTooltip.hidden && sharedTooltip.getAttribute('data-active-id') === o.id;
          if (alreadyShowingThis) {
            sharedTooltip.hidden = true;
            sharedTooltip.removeAttribute('data-active-id');
          } else {
            sharedTooltip.textContent = o.description;
            sharedTooltip.setAttribute('data-active-id', o.id);
            sharedTooltip.hidden = false;
          }
        });
      }
      wrap.appendChild(el);
    });

    wrap.appendChild(sharedTooltip);
  }

  // 2026-09-08 (Lot 8) : "Gravure du cadre" passe d'un champ + (i) isole a
  // un choix par 2 boutons, meme pattern que renderTextureGroup() ci-dessus
  // (option-row--swatch-compact, un (i) qui deplie une info au clic sans
  // selectionner le bouton). Le prix/panier restent bases sur
  // state.engraving (texte reellement saisi, voir hasEngraving plus bas
  // dans ce fichier) — engraveChoice/engraveInfoOpen ne pilotent QUE
  // l'affichage (bouton actif, reveal du champ+image+texte explicatif).
  function renderEngraveGroup() {
    var wrap = root.querySelector('[data-group="engrave"]');
    if (!wrap) return;
    wrap.innerHTML = '';

    var noneBtn = makeOption(
      'option--swatch',
      state.engraveChoice !== 'custom',
      false,
      '<span class="option__swatch-text"><span class="option__swatch-label">Sans gravure</span></span>',
      function () {
        state.engraveChoice = 'none';
        state.engraveInfoOpen = false;
        state.engraving = '';
        if (engraveInput) engraveInput.value = '';
        if (engraveCount) engraveCount.textContent = '0/20';
        engraveDemo = true;
        updateEngravePreview();
        renderAll();
      }
    );
    wrap.appendChild(noneBtn);

    var priceText = (SHOW_PRICES && engravingExtra(state.surface) > 0)
      ? '<span class="option__swatch-price">(+' + money(engravingExtra(state.surface)) + ')</span>'
      : (SHOW_PRICES && ENGRAVING_FREE ? '<span class="option__swatch-price">(offerte)</span>' : '');
    var infoHtml = '<span class="option__info" data-engrave-info tabindex="0" role="button" aria-expanded="' +
      (state.engraveInfoOpen ? 'true' : 'false') + '" aria-label="Voir un exemple de gravure">' +
      '<span class="option__info-mark" aria-hidden="true">i</span></span>';
    var customHtml = '<span class="option__swatch-text"><span class="option__swatch-label">Gravure personnalisée</span>' +
      '<span class="option__swatch-meta">' + priceText + infoHtml + '</span></span>';
    var customBtn = makeOption(
      'option--swatch',
      state.engraveChoice === 'custom',
      false,
      customHtml,
      function () {
        state.engraveChoice = 'custom';
        renderAll();
        if (engraveInput) engraveInput.focus();
      }
    );
    var infoToggle = customBtn.querySelector('[data-engrave-info]');
    if (infoToggle) {
      // stopPropagation : le clic sur le (i) ne doit pas selectionner le
      // bouton "Gravure personnalisee" (meme logique que le (i) Texture de
      // surface ci-dessus) — il deplie juste le champ+image+texte
      // explicatif, meme si "Sans gravure" reste le choix actif.
      var toggleInfo = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        state.engraveInfoOpen = !state.engraveInfoOpen;
        renderAll();
      };
      infoToggle.addEventListener('click', toggleInfo);
      infoToggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') toggleInfo(e);
      });
    }
    wrap.appendChild(customBtn);

    var reveal = root.querySelector('[data-engrave-reveal]');
    var note = root.querySelector('[data-engrave-note]');
    var showFields = state.engraveChoice === 'custom' || state.engraveInfoOpen;
    if (reveal) reveal.hidden = !showFields;
    if (note) note.hidden = !state.engraveInfoOpen;
  }

  function renderLogoGroup() {
    var wrap = root.querySelector('[data-group="logo"]');
    wrap.innerHTML = '';
    LOGO_CHOICES.forEach(function (l) {
      // 2026-08-02 : le tricolore se presente comme un liseret (3 bandes
      // verticales egales bleu/blanc/rouge), pas comme un camembert
      // conic-gradient — feedback explicite avec reference visuelle.
      // 2026-08-04 : l'icone couleur passe d'un rond a cote du texte a un
      // trait fin au-dessus (meme logique que les swatches de finition
      // .option__swatch-img) — boutons plus sobres, "fin et classe".
      var swatch = l.hex
        ? '<span class="option__swatch" style="background:' + l.hex + '"></span>'
        : '<span class="option__swatch" style="background:linear-gradient(to right, #002395 0 33.33%, #fff 33.33% 66.66%, #ED2939 66.66% 100%)"></span>';
      var el = makeOption(
        'option--pill',
        state.logoColor === l.id,
        false,
        swatch + '<span class="option__swatch-label">' + l.label + '</span>',
        function () { state.logoColor = l.id; renderAll(); }
      );
      wrap.appendChild(el);
    });
  }

  function finishSummary() {
    var tab = null;
    FINISH_TABS.forEach(function (t) { if (t.id === state.finish) tab = t; });
    if (!tab) return '';
    if (state.finish === 'brut' || !state.accentColor) return tab.label;
    var color = null;
    paletteFor(state.finish).forEach(function (c) { if (c.id === state.accentColor) color = c; });
    return tab.label + ' ' + (color ? color.name : '');
  }

  // 2026-08-01 : "Option Brut" existe desormais aussi comme produit Shopify
  // dedie (prix 0€ pour l'instant) — on l'ajoute au panier comme les autres
  // types, pour une tracabilite uniforme de la finition choisie sur chaque
  // commande, meme quand elle ne coute rien.
  function finitionAddon() {
    return FINITION_ADDONS[state.finish] || null;
  }

  function renderRecap() {
    var s = surfaceData(state.surface);
    var hasEngraving = state.engraving.trim().length > 0;
    var addon = finitionAddon();
    var addonPrice = addon ? addon.price : 0;
    var texture = textureData(state.texture);
    var texturePrice = textureExtra(texture, state.surface);
    var total = s.price + addonPrice + texturePrice + (hasEngraving ? engravingExtra(state.surface) : 0);
    var logo = null;
    LOGO_CHOICES.forEach(function (l) { if (l.id === state.logoColor) logo = l; });

    root.querySelector('[data-recap="style"]').textContent = s.label;
    root.querySelector('[data-recap="texture"]').textContent = texture ? textureLabel(texture) : '';
    var texturePriceEl = root.querySelector('[data-recap="texture-price"]');
    if (texturePriceEl) texturePriceEl.textContent = (SHOW_PRICES && texturePrice > 0) ? ' (+' + money(texturePrice) + ')' : '';
    root.querySelector('[data-recap="finish"]').textContent = finishSummary();
    var finishPriceEl = root.querySelector('[data-recap="finish-price"]');
    if (finishPriceEl) finishPriceEl.textContent = (SHOW_PRICES && addonPrice > 0) ? ' (+' + money(addonPrice) + ')' : '';
    root.querySelector('[data-recap="logo"]').textContent = logo.label;
    root.querySelector('[data-recap="engraving"]').textContent = hasEngraving ? state.engraving.trim() : 'Aucune';
    // 2026-09-05 (Lot 3) : data-recap="price" / data-float-price existent
    // desormais dans les 3 phases (voir sections/configurateur.liquid) —
    // requetes laissees protegees (if (el)) par prudence, sans effet
    // pratique aujourd'hui.
    var priceEl = root.querySelector('[data-recap="price"]');
    if (priceEl) priceEl.textContent = money(total);
    var floatPrice = root.querySelector('[data-float-price]');
    if (floatPrice) floatPrice.textContent = money(total);

    // 2026-09-03 : PAS de pont vers HexagonAnalytics ici, contrairement aux
    // autres evenements "hexagon:*" du fichier — renderRecap() (donc cet
    // evenement) se declenche aussi a chaque frappe clavier dans le champ
    // de gravure (voir engraveInput 'input' listener plus bas), donc
    // beaucoup trop bruyant pour de l'analytics sans debounce dedie.
    document.dispatchEvent(new CustomEvent('hexagon:surface-change', { detail: { surface: state.surface } }));
  }

  // 2026-08-01 : main + 4 vignettes reconstruites a chaque changement de
  // config (tamis/finition/logo) — l'ordre repart a 1,2,3,4 (photo
  // principale en position main) meme si l'utilisateur avait clique une
  // vignette pour une config precedente ; le swap au clic (plus bas) reste
  // purement un echange de contenu DOM, inchange.
  // 2026-08-16 : `file_url` (Liquid) ne renvoie JAMAIS une chaine vide pour
  // un fichier absent de Contenu > Fichiers — il construit quand meme une
  // URL plausible, qui 404 au chargement (bug Liquid connu, voir
  // snippets/configurator-media.liquid). MEDIA.photos/logos contiennent
  // donc une cle pour TOUTES les combinaisons possibles, meme celles pas
  // encore uploadees : impossible de detecter cote Liquid/JSON qu'un
  // fichier manque. On detecte a la place au chargement reel de l'image
  // (onerror) et on retombe alors sur le placeholder — cf. placeholderHtml
  // et wirePhotoCellFallback ci-dessous.
  function placeholderHtml(label) {
    return '<div class="media-placeholder media-placeholder--square media-placeholder--sable"><span class="media-placeholder__label">' + label + '</span></div>';
  }
  function photoCellHtml(n, placeholderLabel) {
    var photo = photoUrl(n);
    if (!photo) {
      return placeholderHtml(placeholderLabel);
    }
    var overlay = logoOverlayUrl(n);
    // 2026-08-18 (retours) : photo ET calque doivent apparaitre EXACTEMENT
    // en meme temps, pour donner l'impression d'une seule image complete
    // (jamais "le logo qui vient se poser sur l'image de fond"). Toute la
    // cellule (photo-cell) demarre cachee (--pending, voir CSS) ; les 2
    // <img> chargent toujours en parallele (rien de plus precharge, meme
    // poids reseau), mais on n'enleve --pending qu'une fois les 2 prets
    // (voir wirePhotoCellFallback) : un seul fondu simultane.
    var html = '<div class="configurateur__photo-cell configurateur__photo-cell--pending"><img src="' + photo + '" alt="" loading="lazy">';
    if (overlay) html += '<img src="' + overlay + '" alt="" loading="lazy" class="configurateur__photo-overlay">';
    html += '</div>';
    return html;
  }
  // A appeler juste apres avoir injecte photoCellHtml(...) dans container
  // (container = l'element dont on vient de definir innerHTML). Sans effet
  // si photoCellHtml a deja rendu le placeholder (pas de <img> a surveiller).
  function wirePhotoCellFallback(container, placeholderLabel) {
    var cell = container.querySelector('.configurateur__photo-cell');
    if (!cell) return;
    var imgs = cell.querySelectorAll('img');
    if (!imgs.length) return;
    var mainImg = imgs[0];
    var overlayImg = imgs[1] || null;
    var pending = overlayImg ? 2 : 1;
    function maybeReveal() {
      pending--;
      if (pending <= 0) cell.classList.remove('configurateur__photo-cell--pending');
    }
    function failMain() {
      container.innerHTML = placeholderHtml(placeholderLabel);
    }
    // .complete peut deja etre vrai en cache (succes OU echec — naturalWidth
    // distingue les 2 cas) : on ne repose alors PAS sur un evenement
    // load/error qui ne se redeclenchera jamais pour une ressource deja
    // terminee.
    if (mainImg.complete) {
      if (mainImg.naturalWidth > 0) { maybeReveal(); } else { failMain(); return; }
    } else {
      mainImg.addEventListener('load', maybeReveal, { once: true });
      mainImg.addEventListener('error', failMain, { once: true });
    }
    if (overlayImg) {
      if (overlayImg.complete) {
        if (overlayImg.naturalWidth > 0) { maybeReveal(); } else { overlayImg.remove(); maybeReveal(); }
      } else {
        overlayImg.addEventListener('load', maybeReveal, { once: true });
        overlayImg.addEventListener('error', function () {
          overlayImg.remove();
          maybeReveal(); // logo absent ne doit pas bloquer indefiniment la revelation de la photo
        }, { once: true });
      }
    }
  }

  var CONFIGURATEUR_MAIN_LABEL = 'Rendu produit — évolue avec la configuration (surface, finition, logo, gravure)';
  function renderPreview() {
    preloadLogosForCurrentTamis();
    var mainLabel = CONFIGURATEUR_MAIN_LABEL;
    var mainSlot = root.querySelector('[data-configurateur-main]');
    if (mainSlot) {
      mainSlot.innerHTML = photoCellHtml(selectedPhotoIndex, mainLabel);
      wirePhotoCellFallback(mainSlot, mainLabel);
    }
    root.querySelectorAll('[data-configurateur-thumb]').forEach(function (thumb, i) {
      var n = i + 1;
      var slot = thumb.querySelector('.option__inner');
      if (!slot) return;
      var label = 'Photo ' + n;
      slot.innerHTML = photoCellHtml(n, label);
      wirePhotoCellFallback(slot, label);
      thumb.setAttribute('aria-pressed', n === selectedPhotoIndex ? 'true' : 'false');
    });
  }

  function renderAll() {
    // 2026-08-17 : renderPreview() DOIT s'executer apres tous les groupes
    // qui normalisent/choisissent une valeur par defaut dans `state`
    // (renderFinishGroup notamment, qui retombe sur la 1re couleur active
    // si state.accentColor est vide/invalide) — sinon renderPreview lit un
    // accentColor pas encore corrige et affiche aucune photo/calque tant
    // qu'on n'a pas explicitement recliqué sur la couleur deja
    // selectionnee visuellement (bug signale : "flocons dores" visible sur
    // le bouton mais pas sur le rendu produit tant qu'on n'a pas recliqué).
    renderStyleGroup();
    renderTamisModule();
    renderTextureGroup();
    renderFinishGroup();
    renderLogoGroup();
    renderEngraveGroup();
    renderPreview();
    renderRecap();
  }

  // 2026-09-08 (Lot 8) : le champ texte + son compteur restent des elements
  // STATIQUES du markup (sections/configurateur.liquid), jamais regeneres
  // par renderEngraveGroup() (qui ne touche que [data-group="engrave"],
  // les 2 boutons) — memes references conservees telles quelles pour la
  // restauration depuis le panier plus bas (restoreFromCartIfEditing).
  var engraveInput = root.querySelector('[data-engrave-input]');
  var engraveCount = root.querySelector('[data-engrave-count]');
  // 2026-09-18 (branche dev) : apercu en temps reel — recopie le texte
  // saisi par-dessus l'image "Espace_gravure_vide" (voir
  // .configurateur__engrave-preview-text dans base.css). Element statique
  // du markup, jamais regenere, comme engraveInput/engraveCount ci-dessus.
  var engravePreviewText = root.querySelector('[data-engrave-preview-text]');
  var engravePreviewZone = root.querySelector('.configurateur__engrave-preview');
  // Texte de demonstration "Maxime" tant que le client n'a pas clique dans le
  // champ (jamais envoye au panier : state.engraving reste vide).
  var engraveDemo = true;
  // 2026-09-18 (fix "...") : plutot que de tronquer au-dela d'une largeur
  // fixe (text-overflow:ellipsis, retire de base.css), on reduit le texte
  // via --engrave-zone-scale pour que les 20 caracteres max (maxlength de
  // data-engrave-input) restent TOUJOURS entierement visibles.
  //
  // 2026-09-18 (fix bis, "tout le texte n'apparait pas") : la 1re version
  // combinait une boite a largeur FIXE (--engrave-zone-width) + overflow:
  // hidden + un scale() applique par-dessus pour compenser — ca ne marche
  // pas, un scale() ne "recupere" jamais du texte deja coupe par un
  // overflow:hidden sur une boite dont la largeur ne change pas : le clip
  // se fait sur la geometrie de mise en page, AVANT le transform (voir
  // commentaire dans base.css). Desormais .configurateur__engrave-preview-
  // text est en largeur naturelle (max-content, jamais coupee) : offsetWidth
  // reflete donc la vraie largeur du texte au scale 1 (le transform n'a
  // aucun effet sur les proprietes offset*/client*, uniquement visuel). La
  // largeur disponible se calcule a part, a partir de la zone parente
  // (.configurateur__engrave-preview) et de --engrave-zone-width.
  function fitEngravePreviewText() {
    if (!engravePreviewText || !engravePreviewZone) return;
    engravePreviewText.style.setProperty('--engrave-zone-scale', 1);
    if (!state.engraving) return;
    var zoneWidthPercent = parseFloat(
      getComputedStyle(engravePreviewZone).getPropertyValue('--engrave-zone-width')
    ) || 65;
    var availableWidth = engravePreviewZone.clientWidth * (zoneWidthPercent / 100);
    var naturalWidth = engravePreviewText.offsetWidth;
    if (availableWidth > 0 && naturalWidth > availableWidth) {
      // Marge de securite (0.96) : le fallback (police pas encore chargee,
      // voir font-display:swap) a des metriques legerement differentes
      // d'Animal Chariot, on evite un debordement d'1-2px au swap.
      var scale = (availableWidth / naturalWidth) * 0.96;
      engravePreviewText.style.setProperty('--engrave-zone-scale', scale);
    }
  }
  function updateEngravePreview() {
    if (!engravePreviewText) return;
    if (state.engraving) engraveDemo = false;
    engravePreviewText.textContent = (engraveDemo && !state.engraving) ? 'Maxime' : state.engraving;
    fitEngravePreviewText();
  }
  // La largeur disponible (calculee depuis clientWidth de la zone) change
  // avec le viewport (colonne pleine largeur en mobile, moitie en desktop) :
  // re-ajuste le scale au resize, debounce leger (redimensionnement rapide
  // = pas besoin de recalculer a chaque pixel).
  var engravePreviewResizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(engravePreviewResizeTimer);
    engravePreviewResizeTimer = window.setTimeout(fitEngravePreviewText, 150);
  });
  // Une fois la vraie police chargee (font-display:swap = rendu immediat
  // avec la police de secours en attendant), les metriques changent :
  // on recalibre le scale sur le texte deja tape, s'il y en a un.
  if (window.document && document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { fitEngravePreviewText(); });
  }
  updateEngravePreview();
  if (engraveInput) {
    // Un VRAI clic/toucher dans le champ efface le texte de demonstration.
    // (Pas l'evenement focus : le bouton "Gravure personnalisee" donne
    // lui-meme le focus au champ par programme, ce qui effacait la demo
    // immediatement.)
    engraveInput.addEventListener('pointerdown', function () {
      if (engraveDemo) { engraveDemo = false; updateEngravePreview(); }
    });
    engraveInput.addEventListener('input', function (e) {
      state.engraving = e.target.value;
      // Un texte saisi vaut selection implicite de "Gravure personnalisee"
      // (cas : champ ouvert via le (i) seul, sans avoir clique le bouton).
      if (state.engraving.trim().length > 0) state.engraveChoice = 'custom';
      if (engraveCount) engraveCount.textContent = state.engraving.length + '/20';
      updateEngravePreview();
      renderRecap();
    });
  }

  // 2026-08-17 : le clic sur une vignette SELECTIONNE la photo affichee en
  // grand (met a jour selectedPhotoIndex + re-rend), sans plus echanger le
  // contenu des vignettes entre elles — demande explicite (l'ordre 1-7 des
  // vignettes doit rester fixe, "1 est toujours la premiere du carrousel").
  // Remplace l'ancien mecanisme par outerHTML swap (2026-07-30), qui
  // deplacait physiquement les photos et perdait au passage les listeners
  // onerror de wirePhotoCellFallback a chaque clic.
  root.querySelectorAll('[data-configurateur-thumb]').forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      selectedPhotoIndex = i + 1;
      renderPreview();
    });
  });

  renderAll();

  // 2026-08-16 : carrousel de vignettes (7 photos, 4 visibles a la fois) —
  // meme principe que assets/preuves-terrain-carousel.js (geometrie reelle
  // du DOM, jamais un nombre visible suppose/code en dur ; fleches qui
  // deplacent d'une vignette a la fois ; synchronisation avec le scroll
  // tactile natif, qui gere deja le swipe sans JS dedie). Pas de points de
  // pagination ici : les vignettes elles-memes servent deja de reperes
  // visuels (aria-pressed sur celle qui correspond a la photo principale).
  // Independant du clic-swap (data-configurateur-thumb, cable plus haut) :
  // faire defiler le carrousel ne change jamais la photo principale, seul
  // un clic sur une vignette le fait.
  (function initThumbsCarousel() {
    var carousel = root.querySelector('[data-configurateur-thumbs]');
    var viewport = root.querySelector('[data-configurateur-thumbs-viewport]');
    var prevBtn = root.querySelector('[data-configurateur-thumbs-prev]');
    var nextBtn = root.querySelector('[data-configurateur-thumbs-next]');
    if (!carousel || !viewport) return;
    var items = Array.prototype.slice.call(viewport.querySelectorAll('[data-configurateur-thumb]'));
    if (!items.length) return;

    var total = items.length;
    var startIndex = 0;
    var visibleCount = 1;

    function computeVisibleCount() {
      var viewportWidth = viewport.clientWidth;
      var itemWidth = items[0].getBoundingClientRect().width;
      if (!itemWidth) return 1;
      var gap = parseFloat(window.getComputedStyle(viewport).columnGap || window.getComputedStyle(viewport).gap || '0') || 0;
      var count = Math.floor((viewportWidth + gap + 0.5) / (itemWidth + gap));
      return Math.max(1, Math.min(count, total));
    }
    function maxStartIndex() { return Math.max(0, total - visibleCount); }
    function clampStart(i) { return Math.max(0, Math.min(maxStartIndex(), i)); }
    function updateScrollableState() {
      visibleCount = computeVisibleCount();
      carousel.classList.toggle('is-scrollable', total > visibleCount);
    }
    function updateArrows(index) {
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxStartIndex();
    }
    function goTo(index) {
      var clamped = clampStart(index);
      var target = items[clamped];
      if (!target) return;
      startIndex = clamped;
      viewport.scrollTo({
        left: target.offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
      updateArrows(clamped);
    }

    var ticking = false;
    function syncFromScroll() {
      var scrollLeft = viewport.scrollLeft;
      var closest = 0;
      var closestDistance = Infinity;
      items.forEach(function (item, i) {
        var distance = Math.abs(item.offsetLeft - scrollLeft);
        if (distance < closestDistance) { closestDistance = distance; closest = i; }
      });
      var clamped = clampStart(closest);
      if (clamped !== startIndex) { startIndex = clamped; updateArrows(clamped); }
    }
    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { syncFromScroll(); ticking = false; });
    }, { passive: true });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(startIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(startIndex + 1); });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        updateScrollableState();
        var clamped = clampStart(startIndex);
        var target = items[clamped];
        if (target) viewport.scrollTo({ left: target.offsetLeft, behavior: 'auto' });
        startIndex = clamped;
        updateArrows(clamped);
      }, 150);
    });

    // 2026-08-27 (fix) : appeler updateScrollableState() ici, tout de suite
    // apres l'injection des vignettes (renderPreview vient d'ecrire leur
    // innerHTML), peut mesurer une largeur pas encore stabilisee par le
    // navigateur (layout/paint pas termine au meme tick de script) —
    // observe en prod avec exactement 4 vignettes pour 4 visibles : la
    // fleche restait affichee au 1er chargement alors qu'un simple resize
    // la faisait disparaitre aussitot (recalcul correct a ce moment-la).
    // requestAnimationFrame (x2, le 2e apres le prochain paint reel) donne
    // au navigateur le temps de finir sa mise en page avant la 1re mesure.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        updateScrollableState();
        updateArrows(startIndex);
      });
    });
  })();

  // 2026-08-18 (retours) : zoom (150%) sur la photo principale, point focal
  // qui SUIT le curseur — le scale(1.5) reste en CSS pur (:hover, voir
  // base.css), mais un vrai suivi du curseur n'est possible qu'en JS
  // (mousemove -> transform-origin en %, seule facon de lire la position
  // de la souris). root.querySelector sur [data-configurateur-main] reste
  // valide a travers les re-rendus (seul son innerHTML est remplace par
  // renderPreview, jamais l'element lui-meme) : listeners attaches une
  // seule fois ici suffisent.
  //
  // 2026-08-19 (retours) :
  // - Desktop : un clic PENDANT le survol ajoute un zoom "boost" de 50
  //   points supplementaires (150% -> 200%, voir .is-boosted et le
  //   scale(2) associe dans base.css). Reinitialise a chaque sortie de
  //   survol (mouseleave), pour repartir a 150% au prochain survol.
  // - Tactile : 1er tap = active .is-zoomed (point focal centre). Un
  //   touchmove APRES coup, alors que .is-zoomed est actif, deplace le
  //   point focal (meme mecanisme que mousemove desktop) au lieu de
  //   scroller la page (preventDefault, listener non-passif) — distingue
  //   ce drag-pan d'un simple tap via dragMoved (le "click" synthetise en
  //   fin de geste tactile ne doit alors PAS re-basculer .is-zoomed). Un
  //   tap simple (sans deplacement) sur la photo ou ailleurs sur la page
  //   continue de basculer/fermer le zoom comme avant.
  (function initPreviewZoom() {
    var previewInner = root.querySelector('[data-configurateur-main]');
    if (!previewInner) return;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canHover) {
      previewInner.addEventListener('mousemove', function (e) {
        var rect = previewInner.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));
        previewInner.style.setProperty('--configurateur-zoom-x', x + '%');
        previewInner.style.setProperty('--configurateur-zoom-y', y + '%');
      });
      previewInner.addEventListener('click', function () {
        previewInner.classList.toggle('is-boosted');
      });
      previewInner.addEventListener('mouseleave', function () {
        previewInner.classList.remove('is-boosted');
      });
      return;
    }

    var dragMoved = false;
    function resetZoomOrigin() {
      previewInner.style.removeProperty('--configurateur-zoom-x');
      previewInner.style.removeProperty('--configurateur-zoom-y');
    }
    previewInner.addEventListener('touchstart', function () {
      dragMoved = false;
    }, { passive: true });
    previewInner.addEventListener('touchmove', function (e) {
      if (!previewInner.classList.contains('is-zoomed')) return; // pas zoome : laisse le scroll normal de la page
      if (!e.touches.length) return;
      e.preventDefault(); // empeche le scroll de la page pendant le pan du zoom
      dragMoved = true;
      var touch = e.touches[0];
      var rect = previewInner.getBoundingClientRect();
      var x = ((touch.clientX - rect.left) / rect.width) * 100;
      var y = ((touch.clientY - rect.top) / rect.height) * 100;
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));
      // 2026-08-19 (retours) : "quand on descend le pouce, ca descend le
      // zoom" — ressenti invisible/naturel invite a un mouvement inverse
      // (glisser le doigt vers le bas revele la partie du HAUT de l'image,
      // comme deplacer la "camera" plutot que faire suivre un point au
      // doigt). Axes inverses (100 - x / 100 - y) uniquement ici, pas sur
      // le mousemove desktop (non concerne par ce retour).
      previewInner.style.setProperty('--configurateur-zoom-x', (100 - x) + '%');
      previewInner.style.setProperty('--configurateur-zoom-y', (100 - y) + '%');
    }, { passive: false });
    previewInner.addEventListener('click', function (e) {
      e.stopPropagation();
      if (dragMoved) { dragMoved = false; return; } // c'etait un pan, pas un tap
      var willZoom = !previewInner.classList.contains('is-zoomed');
      previewInner.classList.toggle('is-zoomed', willZoom);
      if (!willZoom) resetZoomOrigin();
    });
    document.addEventListener('click', function () {
      previewInner.classList.remove('is-zoomed');
      resetZoomOrigin();
    });
  })();

  // 2026-07-31 : ajout panier reel — pas de vraie variante Shopify par
  // finition/logo/gravure (demande explicite, stock porte uniquement par
  // le produit raquette). La raquette part comme 1re ligne avec toutes les
  // infos choisies en properties (visibles dans le panier/la commande) ;
  // le supplement de finition (si pas Brut) et la gravure (si texte saisi)
  // partent chacun comme leur PROPRE ligne, via le produit Shopify dedie
  // (window.HexagonFinitionAddons / window.HexagonEngravingVariantId) —
  // c'est ce qui garantit que le total facture correspond exactement au
  // total affiche, sans mecanisme de prix "a la main".
  var RAQUETTE_VARIANTS = window.HexagonRaquetteVariants || {};
  var errorEl = root.querySelector('[data-configurateur-error]');
  var isSubmitting = false;

  function showCartError(message) {
    if (!errorEl) return;
    errorEl.innerHTML = '';
    errorEl.appendChild(document.createTextNode(message + ' '));
    var retryBtn = document.createElement('button');
    retryBtn.type = 'button';
    retryBtn.className = 'link-underline';
    retryBtn.textContent = 'Réessayer';
    retryBtn.addEventListener('click', submitToCart);
    errorEl.appendChild(retryBtn);
    errorEl.hidden = false;
  }
  function hideCartError() {
    if (errorEl) errorEl.hidden = true;
  }

  // 2026-08-07 (brief "Formulaires Opening et notification flottante") :
  // '.configurateur__recap .btn' matchait AUSSI le bouton "Etre informe du
  // lancement" du formulaire de contact en phase Opening (les 2 boutons
  // vivent sous .configurateur__recap selon la phase, voir sections/
  // configurateur.liquid) — submitToCart() lui etait alors attache par
  // erreur, capable d'ajouter au panier / rediriger vers /cart au clic sur
  // ce qui est pourtant une simple prise de contact. Hook dedie
  // data-configurateur-cart-cta (pose uniquement sur le bouton rendu en
  // phase 'live', voir snippets/button.liquid) : plus aucune ambiguite.
  var recapCtaBtn = root.querySelector('[data-configurateur-cart-cta]');
  var recapCtaLabel = recapCtaBtn ? recapCtaBtn.querySelector('span') : null;
  var recapCtaDefaultText = recapCtaLabel ? recapCtaLabel.textContent : '';
  function setSubmitting(loading) {
    isSubmitting = loading;
    if (!recapCtaBtn) return;
    recapCtaBtn.classList.toggle('btn--disabled', loading);
    recapCtaBtn.setAttribute('aria-disabled', loading ? 'true' : 'false');
    if (recapCtaLabel) recapCtaLabel.textContent = loading ? 'Ajout en cours…' : recapCtaDefaultText;
  }

  // 2026-08-01 : identifiant unique de configuration (brief panier §2) —
  // partage par toutes les lignes reelles d'UNE raquette configuree
  // (raquette + supplement finition + gravure), pour que la page panier
  // les regroupe en une seule carte et que "Modifier ma configuration"
  // puisse retrouver/mettre a jour exactement ces lignes-la.
  function buildConfigId() {
    return 'raq_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  // Supprime les lignes existantes d'une config (avant reajout) quand on
  // valide une modification depuis ?edit=<id> — evite de dupliquer la
  // raquette en 2e ligne au lieu de mettre a jour la 1re (brief §2).
  // /cart/change.js n'accepte qu'une ligne a la fois : enchainement
  // sequentiel (pas Promise.all) pour ne pas envoyer plusieurs requetes de
  // modification concurrentes sur le meme panier.
  function removeExistingConfigLines(configId) {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var keys = cart.items
          .filter(function (item) { return item.properties && item.properties._config_id === configId; })
          .map(function (item) { return item.key; });
        return keys.reduce(function (chain, key) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          });
        }, Promise.resolve());
      });
  }

  function submitToCart() {
    if (isSubmitting) return;
    var s = surfaceData(state.surface);
    // Variante "tout compris" (surface + gravure incluses dans le prix) quand
    // elle existe ; sinon retour a la variante de base + lignes annexes.
    var matrix = (window.HexagonRaquetteMatrix || {})[state.surface] || {};
    var sablee = state.texture === 'texturee-sablee';
    var engravedBilled = state.engraving.trim().length > 0 && !ENGRAVING_FREE;
    var matrixKey = (sablee ? 's' : 't') + (engravedBilled ? 'g' : 'n');
    var matrixVariantId = matrix[matrixKey];
    var raquetteVariantId = matrixVariantId || RAQUETTE_VARIANTS[state.surface];
    if (!raquetteVariantId) {
      showCartError('Cette raquette n\'est pas disponible à la vente pour le moment.');
      return;
    }
    hideCartError();
    setSubmitting(true);
    trackEvent('add-click', { surface: state.surface });

    var logo = null;
    LOGO_CHOICES.forEach(function (l) { if (l.id === state.logoColor) logo = l; });
    var hasEngraving = state.engraving.trim().length > 0;
    var addon = finitionAddon();
    var texture = textureData(state.texture);
    var configId = EDITING_CONFIG_ID || buildConfigId();

    // Propriete cachees (prefixe _) : jamais affichees dans le panier
    // (sections/main-cart.liquid les filtre), utilisees uniquement pour
    // regrouper les lignes, afficher l'image reelle et rouvrir le
    // configurateur pre-rempli.
    var hiddenProps = {
      _config_id: configId,
      _display_name: 'Raquette Hexagon — ' + s.label,
      _photo_url: photoUrl(1),
      _logo_url: logoOverlayUrl(1),
      _config_json: JSON.stringify({
        surface: state.surface,
        finish: state.finish,
        accentColor: state.accentColor,
        logoColor: state.logoColor,
        engraving: hasEngraving ? state.engraving.trim() : '',
        texture: state.texture
      })
    };
    var raquetteProperties = Object.assign({}, hiddenProps, {
      'Type de jeu': s.label,
      'Surface de frappe': texture ? textureLabel(texture) : '',
      'Couleur surface': finishSummary(),
      'Couleur logo': logo ? logo.label : ''
    });
    if (hasEngraving) raquetteProperties['Gravure'] = state.engraving.trim();

    var items = [{ id: raquetteVariantId, quantity: 1, properties: raquetteProperties }];
    // 2026-08-01 : une ligne panier separee n'a de sens que si elle facture
    // reellement quelque chose — a 0€ elle fait juste doublon avec la
    // propriete "Couleur surface" deja affichee sur la ligne raquette, et
    // apparait telle quelle (gratuite, non masquable) jusque dans le
    // checkout Shopify natif, qu'on ne peut pas personnaliser sur ce plan.
    if (addon && addon.id && addon.price > 0) {
      items.push({ id: addon.id, quantity: 1, properties: { _config_id: configId, 'Pour': s.label + ' — ' + finishSummary() } });
    }
    if (!matrixVariantId && texture && texture.variantId && texture.price > 0) {
      items.push({ id: texture.variantId, quantity: 1, properties: { _config_id: configId, 'Pour': s.label } });
    }
    if (!matrixVariantId && hasEngraving && !ENGRAVING_FREE && window.HexagonEngravingVariantId) {
      items.push({ id: window.HexagonEngravingVariantId, quantity: 1, properties: { _config_id: configId, 'Pour': s.label, 'Texte grave': state.engraving.trim() } });
    }

    var removeOld = EDITING_CONFIG_ID ? removeExistingConfigLines(EDITING_CONFIG_ID) : Promise.resolve();

    removeOld
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'L\'ajout au panier n\'a pas abouti. Réessayez.'); });
        return res.json();
      })
      .then(function () {
        trackEvent('add-success', { surface: state.surface, editing: !!EDITING_CONFIG_ID });
        try { if (window.HexagonTracking) window.HexagonTracking.completed('racket_full', trackingConfig(configId)); } catch (trackErr) { /* ignore */ }
        window.location.href = '/cart';
      })
      .catch(function (err) {
        setSubmitting(false);
        trackEvent('add-error', { message: err.message });
        showCartError(err.message || 'L\'ajout au panier n\'a pas abouti. Réessayez.');
      });
  }

  // 2026-09-05 (Lot 3) : SHOW_PRICES est desormais TOUJOURS true (les prix
  // s'affichent des la phase "opening") — ce n'est donc plus lui qui gate
  // submitToCart() (ajout panier reel), mais l'absence du bouton lui-meme
  // dans le DOM (data-configurateur-cart-cta n'est rendu que si
  // settings.site_phase == 'live', voir sections/configurateur.liquid) :
  // recapCtaBtn vaut null tant que ce n'est pas le cas, ce if reste donc
  // une garde reelle. SHOW_PRICES garde explicitement en plus, au cas ou
  // un futur refactor ferait apparaitre ce bouton plus tot sans repasser
  // ici.
  if (SHOW_PRICES && recapCtaBtn) {
    recapCtaBtn.addEventListener('click', function (e) {
      e.preventDefault();
      submitToCart();
    });
  }

  // 2026-08-08 : l'interception AJAX du formulaire "Etre informe du
  // lancement" (.configurateur__notify) a ete deplacee tout en haut de ce
  // fichier (voir le try/catch juste apres "var root = ..."), pour
  // s'attacher AVANT tout code susceptible d'echouer plus bas — voir le
  // commentaire a cet endroit pour le detail du bug corrige.

  // Restauration depuis ?edit=<id> : cherche dans le panier actuel la
  // ligne raquette portant ce _config_id, reapplique son etat sauvegarde
  // (_config_json) et rafraichit l'affichage. Echec silencieux (config
  // introuvable/panier vide) : le configurateur reste utilisable avec ses
  // valeurs par defaut plutot que de bloquer la page.
  function restoreFromCartIfEditing() {
    if (!EDITING_CONFIG_ID) return;
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var match = null;
        cart.items.forEach(function (item) {
          if (!match && item.properties && item.properties._config_id === EDITING_CONFIG_ID && item.properties._config_json) {
            match = item;
          }
        });
        if (!match) return;
        var saved = JSON.parse(match.properties._config_json);
        state.surface = saved.surface || state.surface;
        state.finish = saved.finish || state.finish;
        state.accentColor = saved.accentColor || state.accentColor;
        state.logoColor = saved.logoColor || state.logoColor;
        state.texture = saved.texture || state.texture;
        state.engraving = saved.engraving || '';
        state.engraveChoice = state.engraving ? 'custom' : 'none';
        if (engraveInput) engraveInput.value = state.engraving;
        if (engraveCount) engraveCount.textContent = state.engraving.length + '/20';
        updateEngravePreview();
        renderAll();
      })
      .catch(function () { /* config introuvable — on garde les valeurs par defaut */ });
  }
  restoreFromCartIfEditing();

  // Barre flottante mobile (voir sections/configurateur.liquid) : visible
  // des que 60% du premier visuel produit (.configurateur__preview .cadre-hex)
  // est visible a l'ecran ; si on remonte et repasse sous 60%, elle
  // disparait. Elle reste ensuite visible jusqu'a ce que le vrai bouton
  // "Valider ma raquette" du bloc recap (pas juste le bloc recap dans son
  // ensemble) soit lui-meme visible a 50% — a ce moment elle disparait, le
  // CTA "en dur" du recap prend le relais (jamais duplique a l'ecran).
  // IntersectionObserver plutot qu'un calcul au scroll : les seuils (60% /
  // 50%) sont alors exacts, pas une approximation de position.
  var floatBar = document.querySelector('[data-configurateur-float]');
  var recapEl = root.querySelector('.configurateur__recap');
  var recapCta = recapEl ? recapEl.querySelector('.btn') : null;
  var firstVisual = root.querySelector('.configurateur__preview .cadre-hex');
  if (floatBar && recapCta && firstVisual && 'IntersectionObserver' in window) {
    var visualVisible = false;
    var recapReached = false;

    function updateFloatBar() {
      floatBar.classList.toggle('is-visible', visualVisible && !recapReached);
    }

    var visualObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visualVisible = entry.intersectionRatio >= 0.6;
        updateFloatBar();
      });
    }, { threshold: [0, 0.6, 1] });
    visualObserver.observe(firstVisual);

    var recapObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        recapReached = entry.intersectionRatio >= 0.5;
        updateFloatBar();
      });
    }, { threshold: [0, 0.5, 1] });
    recapObserver.observe(recapCta);

    var floatCta = floatBar.querySelector('[data-configurateur-float-cta]');
    if (floatCta) {
      floatCta.addEventListener('click', function () {
        recapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }
})();
